const formatDate = (date) => {
    let formattedDate = new Date(date)
    const day = formattedDate.toLocaleDateString('en-GB', { day: 'numeric' })

    formattedDate =
        day +
        ' ' +
        formattedDate.toLocaleDateString('en-GB', { month: 'short' }) +
        ' ' +
        formattedDate.toLocaleDateString('en-GB', { year: 'numeric' })

    return formattedDate
}

const fees = (data) => {
    let resultsHTML = ''

    if (data.fees && data.fees.length) {
        data.fees.map((fee) => {
            resultsHTML += `
                <span class="u-size-small u-color-white">
                    <strong class="u-size-big">${fee}</strong>
                </span>
                <br>
            `
        })
        resultsHTML += '<div class="u-mb"></div>'
    }
    return resultsHTML
}

// prettier-ignore
const eventOrTrainingTemplate = (data, extraClass) => {
    return `<div class="grid__item">
            <a href="${data.url}" target="${data.target}" class="article ${extraClass} article--type-event">
                <article class="article__body">
                    <div class="article__header">
                        <div class="tags">
                            <span class="article__tag tag tag--shape-curved">${data.type.charAt(0).toUpperCase()}${data.type.slice(1)}</span>
                            ${data.series ? `<span class="article__tag tag tag--aquamarine tag--shape-curved">${data.series.charAt(0).toUpperCase()}${data.series.slice(1)}</span>` : ''}
                            ${data.upcoming ? '<span class="article__tag tag tag--ruby tag--shape-curved">Upcoming</span>' : ''}
                        </div>
                        <h3 class="article__heading">${data.title}</h3>
                        ${data.subtitle ? `<h5 class="heading--5 u-mb">${data.subtitle}</h5>` : '' }
                        ${fees(data)}
                    </div>
                    <div class="article__main">
                        <div class="article__copy">
                        ${data.days ? `<span class="tag u-ph-half u-mb-half">${data.days}</span>` : ''}
                        ${data.when ? `<p class="u-mb0">When: ${data.when}</p>` : ''}
                        ${data.where ?  `<p>Where: ${data.where}</p>` : ''}
                        </div>
                    </div>
                    <!--<div class="article__footer">
                        ${data.category ? `<span class="article__category"> ${data.category}</span>` : '' }
                    </div>-->
                </article>
            </a>
       </div>`
}

// prettier-ignore
const newsOrInsightTemplate = (data, extraClass) => {
    return `<div class="grid__item">
    <a href="${data.url}" class="article ${extraClass} article--type-${data.type.toLowerCase()}">
        <article class="article__body">
            ${data.thumbnail ? `<figure class="article__media">${data.thumbnail}</figure>` : ''}
            <div class="article__main">
                <div class="article__tag tag tag--shape-curved tag--aquamarine">${data.type.charAt(0).toUpperCase()}${data.type.slice(1)}</div>
                <h3 class="article__heading">${data.title}</h3>
            </div>
            <div class="article__footer">
                ${data.category ? `<span class="article__category">${data.category}</span>` : '' }
                <time datetime="${data.publicDate}" class="article__date">${formatDate(data.publicDate)}</time>
                ${data.membersOnly ? '<span class="article__privacy tag u-weight-light tag--white">Members Only</span>' : ''}
            </div>
        </article>
    </a>
</div>`
}

// prettier-ignore
const template = (i, data, extraClass = '') => {

    switch (data.type.toLowerCase()) {
        case 'insights':
            return newsOrInsightTemplate(data, extraClass)

        case 'news':
            return newsOrInsightTemplate(data, extraClass)

        case 'topics':
            return `<div class="grid__item">
            <a href="${data.url}" class="article ${extraClass} article--type-topics ${(data.primaryColour) ? `article--bg-${data.primaryColour.toLowerCase()}` : ''}">
                <article class="article__body">
                    <figure class="article__media">
                        <svg width="225" height="158" class="article__svg">
                            <use xlink:href="/application/themes/rawnet/app/images/sprite.svg#article_pattern"></use>
                        </svg>
                    </figure>
                    <div class="article__main">
                        <div class="article__tag tag tag--shape-curved tag--aquamarine">${data.type.charAt(0).toUpperCase()}${data.type.slice(1)}</div>
                        <h3 class="article__heading">${data.title}</h3>
                    </div>
                    <div class="article__footer">
                        ${data.category ? `<span class="article__category">${data.category}</span>` : '' }
                        <time datetime="${data.publicDate}" class="article__date">${formatDate(data.publicDate)}</time>
                        ${data.membersOnly ? '<span class="article__privacy tag u-weight-light tag--white">Members Only</span>' : ''}
                    </div>
                </article>
            </a>
        </div>`
        case 'research':
            return `<div class="grid__item">
            <a href="${data.url}" class="article ${extraClass} article--type-${data.type.toLowerCase()} ${(data.primaryColour) ? `article--bg-${data.primaryColour.toLowerCase()}` : ''}">
                <article class="article__body">
                    <div class="article__header">
                        <div class="article__tag tag tag--shape-curved">${data.type.charAt(0).toUpperCase()}${data.type.slice(1)}</div>
                        <h3 class="article__heading">${data.title}</h3>
                    </div>
                    <div class="article__main">
                        <div class="article__copy">${data.description}</div>
                    </div>
                    <div class="article__footer">
                        ${data.category ? `<span class="article__category">${data.category}</span>` : '' }
                        <time datetime="${data.publicDate}" class="article__date">${formatDate(data.publicDate)}</time>
                        ${data.membersOnly ? '<span class="article__privacy tag u-weight-light tag--white">Members Only</span>' : ''}
                    </div>
                </article>
            </a>
        </div>`
        case 'policy':
            return `<div class="grid__item">
                    <a href="${data.url}" class="article ${extraClass} article--type-${data.type.toLowerCase()}">
                        <article class="article__body">
                            <div class="article__header">
                                <div class="article__tag tag tag--shape-curved">${data.type.charAt(0).toUpperCase()}${data.type.slice(1)}</div>
                                <h3 class="article__heading">${data.title}</h3>
                            </div>
                            <div class="article__main">
                                <div class="article__copy">${data.description}</div>
                            </div>
                            <div class="article__footer">
                                ${data.category ? `<span class="article__category">${data.category}</span>` : '' }
                                <time datetime="${data.publicDate}" class="article__date">${formatDate(data.publicDate)}</time>
                                ${data.membersOnly ? '<span class="article__privacy tag u-weight-light tag--white">Members Only</span>' : ''}
                            </div>
                        </article>
                    </a>
                </div>`

        case 'event':
        case 'training':
        case 'unit':
            return eventOrTrainingTemplate(data, extraClass)

        default:
            return newsOrInsightTemplate(data, extraClass)
    }
}
export default template
